<div *ngIf="isLogin; else otherTemplate" class="login-page">
  <router-outlet></router-outlet>
</div>

<ng-template #otherTemplate>
  <nz-spin [nzSpinning]="isSpinning" [nzSize]="'large'" class="loginOut-spin">
    <nz-layout class="app-layout" [class.embed-mode]="embedMode">
      <nz-sider
        class="menu-sidebar ant-layout-sider-collapsed"
        nzCollapsible
        nzWidth="160px"
        *ngIf="hasLoggedIn && !hiddenSiderAndHeader && isShowMenu"
        [(nzCollapsed)]="isCollapsed"
        [nzTrigger]="null"
        [nzCollapsedWidth]="60"
      >
        <div
          class="sidebar-logo"
          [ngClass]="{ 'tab-logo-small': isCollapsed }"
          [ngStyle]="{
            background: isCollapsed
              ? 'url(' + defaultMenuLogoSmall + ') no-repeat'
              : 'url(' + defaultMenuLogoBig + ') no-repeat'
          }"
        ></div>
        <ul class="sidebar-ul" nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
          <li nz-submenu routerLink="/basic_form/basic_form">
            <span title>
              <i nz-icon [nzIconfont]="'icon-home'"></i>
              <span>首页</span>
            </span>
          </li>
          <li nz-submenu *ngFor="let menu of menuArray" [nzTitle]="titleTpl">
            <ng-template #titleTpl>
              <i nz-icon [nzIconfont]="menu.icon || 'icon-systemSetting'"></i>
              <span>{{ menu.name }}</span>
            </ng-template>
            <ul *ngFor="let submenu of menu.children">
              <li
                *ngIf="submenu.children && submenu.children.length > 0"
                [nzTitle]="submenu.name"
                nz-submenu
              >
                <ul>
                  <li *ngFor="let leafmenu of submenu.children" nz-menu-item nzMatchRouter>
                    <a [routerLink]="leafmenu.path || currentPath">{{ leafmenu.name }}</a>
                  </li>
                </ul>
              </li>
              <li
                *ngIf="submenu.children && submenu.children.length === 0"
                nz-menu-item
                nzMatchRouter
              >
                <a [routerLink]="submenu.path || currentPath">{{ submenu.name }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </nz-sider>
      <nz-layout>
        <nz-header *ngIf="!hiddenSiderAndHeader && isShowMenu">
          <div class="app-header">
            <span class="header-trigger" (click)="trigger()" *ngIf="hasLoggedIn && isShowMenu">
              <i
                *ngIf="isCollapsed"
                nz-tooltip
                [nzTooltipTitle]="'展开左侧菜单'"
                class="icon iconfont icon-menu-fold"
              ></i>
              <i
                *ngIf="!isCollapsed"
                nz-tooltip
                [nzTooltipTitle]="'折叠左侧菜单'"
                class="icon iconfont icon-menu-unfold"
              ></i>
            </span>
            <div class="rt pro-icon">
              <div class="announcementList">
                <div class="announcement-trigger" (click)="showAnnouncementList($event)">
                  <img src="../assets/images/basic_form/ann-modal/gg.png" alt="" />
                  <span class="badge" *ngIf="announcements.length > 0">{{
                    announcements.length
                  }}</span>
                </div>
                <div
                  class="list"
                  [ngClass]="{ noData: announcements.length === 0 }"
                  *ngIf="isShowAnnouncementList"
                >
                  <p *ngIf="announcements.length > 0">你有{{ announcements.length }}条公告</p>
                  <p *ngIf="announcements.length === 0 && !loadingAnnouncements">暂无公告</p>
                  <nz-spin *ngIf="loadingAnnouncements" nzSimple></nz-spin>
                  <ul class="announcement-dropdown-list" *ngIf="announcements.length > 0">
                    <li
                      *ngFor="let announcement of announcements"
                      class="announcement-dropdown-item"
                    >
                      <div class="announcement-item-left">
                        <span
                          class="announcement-type-badge"
                          [style.color]="getAnnTypeColor(announcement.annType)"
                          [style.backgroundColor]="getAnnTypeBgColor(announcement.annType)"
                          >{{ announcement.annTypeName }}</span
                        >
                        <span class="announcement-title">{{ announcement.title }}</span>
                      </div>
                      <div class="announcement-item-right">
                        <span class="announcement-time"
                          >[{{ announcement.publishTime | slice : 0 : 10 }}]</span
                        >
                        <a
                          class="announcement-details-link"
                          (click)="goToAnnouncementDetail(announcement)"
                          >详情 ></a
                        >
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="todoList">
                <i
                  nz-tooltip
                  nzTooltipPlacement="bottom"
                  [nzTooltipTitle]="'待办事项'"
                  class="icon iconfont icon-upcoming"
                  (click)="showTodoList($event)"
                >
                  <span class="badge" *ngIf="todoListData.length > 0">{{ totalTodo }}</span>
                </i>
                <div class="list" [ngClass]="{ noData: !totalTodo }" *ngIf="isShowTodoList">
                  <p>你有{{ totalTodo }}条未解决的任务</p>
                  <ul>
                    <li *ngFor="let item of todoListData">
                      <a
                        *ngIf="!item.sfth && item.workFlowState !== -1"
                        class="target-url"
                        [href]="item.formUrl"
                        target="_blank"
                      >
                        <div>
                          <span *ngIf="item.custName">{{ item.custName }}</span>
                          <span class="m-r-10 inline-block" *ngIf="item.custCode">({{ item.custCode }})</span>
                          <span class="m-r-10 inline-block">{{ item.processName }}</span>
                          <span *ngIf="item.workFlowState === 0"
                            class="running inline-block m-r-10">进行中</span>
                          <span *ngIf="item.workFlowState === 1" class="running inline-block m-r-10">已完成</span>
                          <span class="inline-block">{{item.createAt | date : 'yyyy-MM-dd HH:mm' }}</span>
                        </div>
                      </a>
                      <!--     sfth：是否退回    -->
                      <div class="todo-item" *ngIf="item.sfth" (click)="returnToEdit(item)">
                        <span *ngIf="item.custName">{{ item.custName }}</span>
                        <span class="m-r-10" *ngIf="item.custCode"> ({{ item.custCode }})</span>
                        <span class="m-r-10">{{ item.processName }}</span>
                        <span class="return m-r-10">撤回重填</span>
                        <span>{{ item.createAt | date : 'yyyy-MM-dd HH:mm' }}</span>
                      </div>
                      <a
                        *ngIf="!item.sfth && item.workFlowState === -1"
                        class="target-url"
                        [href]="item.formUrl"
                        target="_blank"
                      >
                        <span *ngIf="item.custName">{{ item.custName }}</span>
                        <span class="m-r-10" *ngIf="item.custCode"> ({{ item.custCode }})</span>
                        <span class="m-r-10">{{ item.processName }}</span>
                        <span class="refuse m-r-10">不通过</span>
                        <span>{{ item.createAt | date : 'yyyy-MM-dd HH:mm' }}</span>
                      </a>
                    </li>
                  </ul>
                  <div class="more">
                    <a class="target-url" [href]="todoData?.loginUrl" target="_blank">
                      <span> 查看更多 </span>
                      <span class="rt">
                        <i class="icon iconfont icon-unfold"></i>
                      </span>
                    </a>
                  </div>
                </div>
              </div>

              <i
                nz-tooltip
                nzTooltipPlacement="bottom"
                [nzTooltipTitle]="'刷新当前页面'"
                class="icon iconfont icon-refresh"
                (click)="refresh()"
              ></i>
              <app-data-masking-controller *ngIf="showDataMaskingBtn"></app-data-masking-controller>
              <div class="user-info">
                <i class="icon iconfont icon-top-bar-user m-r-8"></i>
                <span class="m-r-6" style="font-size: 10px; vertical-align: top">{{
                  loginUserName
                }}</span>
                <i class="caret-down" nz-icon nzType="caret-down" nzTheme="outline"></i>
                <ul class="more-setting">
                  <li>
                    <a routerLink="/system_configuration/user_info"> 用户信息 </a>
                  </li>
                  <li>
                    <a (click)="showFullScreen()">全屏展示</a>
                  </li>
                  <li *ngIf="rolesList.indexOf('admin') !== -1">
                    <a routerLink="/system_configuration/common_set">基础设置</a>
                  </li>
                  <li *ngIf="rolesList.indexOf('admin') !== -1">
                    <a (click)="clearCache()">重置缓存</a>
                  </li>
                  <!--                  <li *ngIf="isFullScreen">-->
                  <!--                    <a (click)="exitFullScreen()">取消全屏</a>-->
                  <!--                  </li>-->
                  <li>
                    <a (click)="logout()"> 退出登录 </a>
                  </li>
                </ul>
              </div>
            </div>
            <span class="rt search-box" *abpPermission="'BasicSetting.EsQuery'">
              <app-customer-search
                (selectCustomer)="onCustomerSelected($event)"
              ></app-customer-search>
            </span>
          </div>
          <div class="app-header-tabs">
            <nz-tabset [nzType]="'card'">
              <nz-tab
                *ngFor="let tab of tabArray; let i = index"
                [nzTitle]="titleTemplate"
                nzShowPagination="true"
              >
                <ng-template #titleTemplate>
                  <div
                    nz-tab-link
                    class="tabDiv"
                    [ngStyle]="{ left: i === 0 ? '-4px' : -20 * i + 'px' }"
                    [ngClass]="tab.active ? 'activeTab' : ''"
                    [routerLink]="[tab.path]"
                    (click)="tabClick(tab, i)"
                    (contextmenu)="rightClickFun($event, tab, i)"
                  >
                    {{ tab.name }}
                    <i
                      nz-icon
                      nzType="close"
                      (click)="closeTab(tab)"
                      [ngClass]="{ 'tab-close-1': i === 0 }"
                      class="tab-close"
                    ></i>
                  </div>
                </ng-template>
              </nz-tab>
            </nz-tabset>
            <div id="rightClickPlane" class="rightClickPlane" [hidden]="!isShowRightClickPlane">
              <ul>
                <li (click)="closeTabs(1, $event)">关闭其他标签</li>
                <li (click)="closeTabs(2, $event)">关闭全部标签</li>
                <li (click)="closeTabs(3, $event)">关闭左侧标签</li>
                <li (click)="closeTabs(4, $event)">关闭右侧标签</li>
              </ul>
            </div>
          </div>
        </nz-header>
        <nz-content id="main-content"  [ngClass]="isShowMenu ? 'main-content' : 'main-content-max'">
          <div class="inner-content">
            <router-outlet></router-outlet>
          </div>
        </nz-content>

        <nz-footer [hidden]="true" class="main-footer"
          ><div class="footer-content"></div
        ></nz-footer>
      </nz-layout>
    </nz-layout>
  </nz-spin>
  <app-announcement-modal
    [(isModalVisible)]="isPreviewModalVisible"
    [article]="selectedAnnouncement"
  ></app-announcement-modal>
</ng-template>

<ng-template #notification>
  <div style="padding-right: 30px">
    导出中<nz-progress [nzPercent]="downloadPercent" nzStatus="active"></nz-progress>
  </div>
</ng-template>

<nz-modal
  [nzMaskClosable]="false"
  [nzKeyboard]="false"
  [nzClosable]="false"
  [(nzVisible)]="isShowModal"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  nzWrapClassName="userInfoModal"
>
  <ng-template #modalTitle>
    修改密码
  </ng-template>

  <ng-template #modalContent>
    <form nz-form [formGroup]="passswordForm">
      <nz-form-item>
        <nz-form-label [nzNoColon] [nzSm]="6" [nzXs]="24" nzRequired>旧密码</nz-form-label>
        <nz-form-control [nzSpan]="12" nzErrorTip="请输入密码!">
          <input type="password" class="login-input" nz-input formControlName="oldPassword" required/>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzNoColon] [nzSm]="6" [nzXs]="24" nzRequired>新密码</nz-form-label>
        <nz-form-control [nzSpan]="12" [nzErrorTip]="newPwErrorTpl">
          <input type="password" minlength="6" class="login-input" nz-input formControlName="newPassword" required/>
          <ng-template #newPwErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              请输入密码!
            </ng-container>
            <ng-container *ngIf="control.hasError('sameAsOld')">
              新密码不能与旧密码相同!
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-label [nzNoColon] [nzSm]="6" [nzXs]="24" nzRequired>重复新密码</nz-form-label>
        <nz-form-control [nzSpan]="12" nzErrorTip="请输入密码!" [nzErrorTip]="errorTpl">
          <input type="password" class="login-input" nz-input formControlName="checkPassword" required/>
          <ng-template #errorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              请再次输入密码
            </ng-container>
            <ng-container *ngIf="control.hasError('confirm')">
              两次输入的新密码不一致，请重输!
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </form>
    <p class="pwToast"><i class="m-r-10" nz-icon nzType="warning" nzTheme="outline"></i>密码长度不小于8位，至少包含数字、大写字母、小写字母、符号中的四种组合字符，且不能有连续两个相同字符</p>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="primary" (click)="savePassword()" [nzLoading]="isConfirmLoading" [disabled]="passswordForm.invalid">保存</button>
  </ng-template>
</nz-modal>
